import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentFormField } from './ShipmentFormField'

const payableHowOptions = [
    { label: 'Prepaid', value: 'P' },
    { label: 'Collect', value: 'C' },
    { label: 'Payable at Destination', value: 'A' },
    { label: 'Prepaid Else', value: 'Q' },
    { label: 'Collect Else', value: 'D' },
    { label: 'Other', value: 'O' },
]

export const ShipmentQuote = ({ dataState, setDataState }) => {
    const { t } = useTranslation()

    const onQuoteSelect = (_data, _fields, obj) => {
        if (!obj) {
            setDataState(prev => ({
                ...prev,
                IdQuote: null,
                QuoteCode: '',
                Revision: null,
                QuoteAgentLoc: '',
            }))
            return
        }
        setDataState(prev => ({
            ...prev,
            IdQuote: obj.Id || null,
            QuoteCode: obj.QuoteCode || '',
            Revision: obj.Revision != null ? obj.Revision : prev.Revision,
            QuoteAgentLoc: obj.LocationPayCode || '',
            PayableHow: obj.PayableHow || prev.PayableHow,
        }))
    }

    return (
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-file' style={{ fontSize: '18px' }} />
                    {t('Quote')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{
                                display: t('Quote'),
                                code: 'QuoteCode',
                                type: 'foreignKey',
                                entity: 'quote',
                                tableLabel: t('Quote'),
                                filterField: 'QuoteCode',
                                labelFields: ['QuoteCode'],
                                fields: [
                                    { key: 'QuoteCode', value: 'QuoteCode' },
                                    { key: 'Revision', value: 'Revision' },
                                    { key: 'LocationPayCode', value: 'QuoteAgentLoc' },
                                    { key: 'PayableHow', value: 'PayableHow' },
                                    { key: 'Id', value: 'IdQuote' },
                                ],
                            }}
                            index={10}
                            data={dataState}
                            setData={setDataState}
                            returnFunc={onQuoteSelect}
                        />
                        <ShipmentFormField
                            fields={{ display: t('Revision'), code: 'Revision', type: 'disabled', size: '120px' }}
                            index={11}
                            data={dataState}
                            setData={setDataState}
                        />
                        <ShipmentFormField
                            fields={{ display: t('PayableHow'), code: 'PayableHow', type: 'select', options: payableHowOptions }}
                            index={12}
                            data={dataState}
                            setData={setDataState}
                            options={payableHowOptions}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentFormField
                            fields={{ display: t('FreightLineReference'), code: 'FreightLineReference', type: 'text' }}
                            index={13}
                            data={dataState}
                            setData={setDataState}
                        />
<ShipmentFormField
                            fields={{ display: t('FreightReference'), code: 'FreightReference', type: 'text' }}
                            index={15}
                            data={dataState}
                            setData={setDataState}
                        />
                    </div>
                </div>
            }
        />
    )
}
